import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { buildUniqueClassName } from '~/helpers/seo-helpers';
import ArrowLink from '~/components/molecules/ArrowLink.vue';
import CategoryCheckboxFilter from '~/components/organisms/Category/CategoryCheckboxFilter.vue';
import CategoryDimensionsFilter from '~/components/organisms/Category/CategoryDimensionsFilter.vue';
import CategoryTags from '~/components/organisms/Category/CategoryTags.vue';
import TransitionExpand from '~/components/templates/TransitionExpand.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';

const CategoryRangeFilter = () => import('~/components/organisms/Category/CategoryRangeFilter.vue');

const BASIC_FILTERS_LENGTH = 7;
export default {
  name: 'CategoryFiltersBar',
  components: {
    ArrowLink,
    CategoryCheckboxFilter,
    CategoryDimensionsFilter,
    CategoryRangeFilter,
    CategoryTags,
    TransitionExpand
  },
  props: {
    activeFilters: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedFilter: null,
      buildUniqueClassName
    };
  },

  computed: _objectSpread({}, mapGetters({
    productsCount: 'category/productsCount'
  }), {
    validFilters() {
      return this.filters && this.filters.length > 0 ? this.filters.filter(f => f.facets) : [];
    },

    basicFiltersLength() {
      return this.validFilters && this.validFilters.length > BASIC_FILTERS_LENGTH + 1 ? BASIC_FILTERS_LENGTH : BASIC_FILTERS_LENGTH + 1;
    },

    basicFilters() {
      return this.filters.slice(0, this.basicFiltersLength);
    },

    seeResultsLabel() {
      return this.productsCount ? "".concat(this.$t('btn-see-results'), " (").concat(this.productsCount, ")") : this.$t('btn-see-results');
    },

    activeTags() {
      return this.activeFilters.filter(e => e.label);
    }

  }),
  watch: {
    activeFilters() {
      this.selectedFilter = this.selectedFilter ? this.filters.find(f => f.name === this.selectedFilter.name) : null;
    },

    basicFilters() {
      this.selectedFilter = null;
    }

  },
  methods: {
    selectFilter(filter) {
      this.selectedFilter = this.selectedFilter !== filter ? filter : null;
    },

    openLayer() {
      this.$root.$emit('open-layer', {
        state: true,
        name: 'FiltersLayer',
        filters: this.validFilters
      });
      window.document.querySelector('body').style.overflow = 'hidden';
      return false;
    }

  }
};